import DeleteIcon from "@mui/icons-material/Delete";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { alpha, IconButton, Paper, styled, Typography, useTheme } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { t } from "i18next";
import { Link } from "react-router-dom";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { useRouter } from "../../../../helper-functions/useRouterReplacement";
import { useDispatch, useSelector } from "react-redux";
import CustomDialogConfirm from "../../../custom-dialog/confirm/CustomDialogConfirm";
import { useAddStoreToWishlist } from "../../../../api-manage/hooks/react-query/wish-list/useAddStoreToWishLists";
import { useWishListStoreDelete } from "../../../../api-manage/hooks/react-query/wish-list/useWishListStoreDelete";
import { getCurrentModuleType } from "../../../../helper-functions/getCurrentModuleType";
import {
	addWishListStore,
	removeWishListStore,
} from "../../../../redux/slices/wishList";
import { CustomStackFullWidth } from "../../../../styled-components/CustomStyles.style";
import { textWithEllipsis } from "../../../../styled-components/TextWithEllipsis";
import { not_logged_in_message } from "../../../../utils/toasterMessages";
import ClosedNow from "../../../closed-now";
import CustomImageContainer from "../../../CustomImageContainer";
import PlaceIconComponent from "../../../PlaceIconComponent";
import RatingStar from "../../../RatingStar";
const CardWrapper = styled(Paper)(({ theme }) => ({
	padding: "2rem 1rem",
	height: "100%",
	backgroundColor: theme.palette.background.paper,
	border: `1px solid ${theme.palette.divider}`,
	borderRadius: "16px",
	boxShadow: theme.palette.mode === 'dark'
		? `0px 4px 12px ${alpha(theme.palette.common.black, 0.2)}`
		: "0px 4px 12px rgba(0, 0, 0, 0.08)",
	cursor: "pointer",
	position: "relative",
	transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
	"&:hover": {
		transform: "translateY(-4px)",
		boxShadow: theme.palette.mode === 'dark'
			? `0px 12px 32px ${alpha(theme.palette.common.black, 0.4)}`
			: "0px 12px 32px rgba(0, 0, 0, 0.12)",
		borderColor: alpha(theme.palette.primary.main, 0.3),
	},
}));
const ImageWrapper = styled(Box)(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	height: "80px",
	width: "80px",
	borderRadius: "50%",
	border: "3px solid",
	borderColor: theme.palette.secondary.light,
	position: "relative",
}));
export const HeartWrapper = styled(IconButton)(({ theme, top, right }) => ({
	zIndex: 1,
	width: "36px",
	height: "36px",
	backgroundColor: theme.palette.background.paper,
	border: `1px solid ${theme.palette.divider}`,
	borderRadius: "50%",
	boxShadow: theme.palette.mode === 'dark'
		? `0px 4px 8px ${alpha(theme.palette.common.black, 0.3)}`
		: "0px 4px 8px rgba(0, 0, 0, 0.1)",
	position: "absolute",
	top: top,
	textAlign: "center",
	right: right,
	color: theme.palette.pink.main,
	transition: "all 0.3s ease-in-out",
	"&:hover": {
		backgroundColor: theme.palette.mode === 'dark'
			? alpha(theme.palette.background.paper, 0.9)
			: theme.palette.background.paper,
		transform: "scale(1.1)",
		boxShadow: theme.palette.mode === 'dark'
			? `0px 6px 12px ${alpha(theme.palette.common.black, 0.4)}`
			: "0px 6px 12px rgba(0, 0, 0, 0.15)",
	},
}));

const StoresInfoCard = (props) => {
	const { data, wishlistcard } = props;
	const id = data?.id ? data?.id : data?.slug;
	const { configData } = useSelector((state) => state.configData);
	const store_image_url = `${configData?.base_urls?.store_image_url}`;
	const moduleId = JSON.parse(window.localStorage.getItem("module"))?.id;
	const router = useRouter();

	const dispatch = useDispatch();
	const [isWishlisted, setIsWishlisted] = useState(false);
	const [openModal, setOpenModal] = useState(false);
	const classes = textWithEllipsis();
	const theme = useTheme();
	const gray = theme.palette.text.secondary;
	const { wishLists } = useSelector((state) => state.wishList);

	let token = undefined;
	if (typeof window !== "undefined") {
		token = localStorage.getItem("token");
	}
	const { mutate: addFavoriteMutation } = useAddStoreToWishlist();
	const addToFavorite = () => {
		if (token) {
			addFavoriteMutation(id, {
				onSuccess: (response) => {
					if (response) {
						dispatch(addWishListStore(data));
						toast.success(response?.message);
					}
				},
				onError: (error) => {
					toast.error(error.response.data.message);
				},
			});
		} else toast.error(t(not_logged_in_message));
	};
	const isInList = (id) => {
		return !!wishLists?.store?.find((wishStore) => wishStore.id === id);
	};
	const onSuccessHandlerForDelete = (res) => {
		dispatch(removeWishListStore(id));
		toast.success(res.message, {
			id: "wishlist",
		});
	};
	const { mutate } = useWishListStoreDelete();
	const deleteWishlistStore = (id) => {
		mutate(id, {
			onSuccess: onSuccessHandlerForDelete,
			onError: (error) => {
				toast.error(error.response.data.message);
			},
		});
	};

	return (
		<Stack sx={{ position: "relative", height: "100%" }}>
			{wishlistcard === "true" ? (
				<HeartWrapper
					onClick={() => setOpenModal(true)}
					top="4%"
					right="5%"
				>
					<DeleteIcon style={{ color: theme.palette.error.light }} />
				</HeartWrapper>
			) : (
				<>
					{!isInList(id) && (
						<HeartWrapper onClick={addToFavorite} top="4%" right="5%">
							<FavoriteBorderIcon />
						</HeartWrapper>
					)}
					{isInList(id) && (
						<HeartWrapper
							onClick={() => deleteWishlistStore(id)}
							top="4%"
							right="5%"
						>
							<FavoriteIcon />
						</HeartWrapper>
					)}
				</>
			)}
			<Link
				onClick={(e) => {
					e.preventDefault();
					const storeId = data?.slug ? data?.slug : data?.id;
					const storeType = getCurrentModuleType() === 'food' ? 'restaurant' : 'supermarket';
					const queryParams = new URLSearchParams({
						id: data?.id,
						[storeType]: data?.id,
						module_id: moduleId,
						store_zone_id: data?.zone_id,
					});
					router.push(`/store/${storeType}?${queryParams.toString()}`);
				}}
			>
				<CardWrapper>
					<CustomStackFullWidth
						alignItems="center"
						justifyContent="center"
						spacing={0.5}
						sx={{ height: "100%" }}
					>
						<ImageWrapper>
							<CustomImageContainer
								src={`${store_image_url}/${data?.logo}`}
								alt={data?.name}
								height="100%"
								width="100%"
								objectFit="cover"
								borderRadius="50%"
							/>
							<ClosedNow
								active={data?.active}
								open={data?.open}
								borderRadius="50%"
							/>
						</ImageWrapper>
						<Typography
							textAlign="center"
							fontWeight="bold"
							className={classes.multiLineEllipsis}
							maxHeight="40px"
							color="text.primary"
						>
							{data?.name}
						</Typography>
						<Stack
							direction="row"
							alignItems="center"
							justifyContent="center"
							spacing={0.5}
						>
							{/*getNumberWithConvertedDecimalPoint(data?.avg_rating, configData?.digit_after_decimal_point)*/}
							<Typography fontWeight="bold" color="text.primary">
								{data?.avg_rating.toFixed(1)}
							</Typography>
							<RatingStar fontSize="16px" color="warning.dark" />
						</Stack>
						<Stack
							direction="row"
							alignItems="center"
							justifyContent="center"
							spacing={0.5}
							alignSelf={wishlistcard === "true" ? "center" : "flex-end"}
						>
							<PlaceIconComponent fontSize="20px" color={gray} />
							<Typography
								variant="body2"
								color={gray}
								className={classes.multiLineEllipsis}
							>
								{data?.address}
							</Typography>
						</Stack>
					</CustomStackFullWidth>
				</CardWrapper>
			</Link>
			<CustomDialogConfirm
				dialogTexts={t("Are you sure you want to  delete this item?")}
				open={openModal}
				onClose={() => setOpenModal(false)}
				onSuccess={() => deleteWishlistStore(id)}
			/>
		</Stack>
	);
};

StoresInfoCard.propTypes = {};

export default StoresInfoCard;
